var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSeenTicketCancellationRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5V9.5H14V3.5H4ZM16.5 6.5C16.5 5.6875 17.1562 5 18 5V2C18 1.1875 17.3125 0.5 16.5 0.5H1.5C0.65625 0.5 0 1.1875 0 2V5C0.8125 5 1.5 5.6875 1.5 6.5C1.5 7.34375 0.8125 8 0 8V11C0 11.8438 0.65625 12.5 1.5 12.5H16.5C17.3125 12.5 18 11.8438 18 11V8C17.1562 8 16.5 7.34375 16.5 6.5ZM15 3.25V9.75C15 10.1875 14.6562 10.5 14.25 10.5H3.75C3.3125 10.5 3 10.1875 3 9.75V3.25C3 2.84375 3.3125 2.5 3.75 2.5H14.25C14.6562 2.5 15 2.84375 15 3.25Z",
    fill: "#CC0605"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSeenTicketCancellationRequest);
export default __webpack_public_path__ + "static/media/notSeenTicketCancellationRequest.940400dcdc3cbc342630237c0d978007.svg";
export { ForwardRef as ReactComponent };